import { useMemo } from 'react'
import {
  DataTable,
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
} from '@/components/ui/data-table'
import { Calculator } from 'lucide-react'
import { createImpuestosColumns } from './impuestosColumns'
import type { CatalogoConMetricas } from '@/hooks/useImpuestosPage'

interface ImpuestosTableProps {
  data: CatalogoConMetricas[]
  isLoading?: boolean
  onVerDetalle: (impuesto: CatalogoConMetricas) => void
}

export function ImpuestosTable({
  data,
  isLoading,
  onVerDetalle,
}: ImpuestosTableProps) {
  const columns = useMemo(
    () => createImpuestosColumns(onVerDetalle),
    [onVerDetalle]
  )

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    initialState: {
      sorting: [
        { id: 'categoria', desc: false },
        { id: 'nombre', desc: false },
      ],
    },
  })

  return (
    <DataTable
      table={table}
      isLoading={isLoading}
      emptyMessage="No hay impuestos en el catálogo"
      emptyIcon={<Calculator className="h-6 w-6 text-muted-foreground" />}
      withVerticalDividers
    />
  )
}
